const messages = {
  custom: {
    max_persons: {
      minIfExist: () =>
        'Le nombre maximum de personne ne peut pas être plus petit que le nombre minimum de personne.',
    },
    min_persons: {
      maxIfExist: () =>
        'Le nombre minimum de personne ne peut pas être plus grand que le nombre maximum de personne',
    },
    price: {
      priceFormat: () =>
        'Le prix est incorrect, il doit être au format 20 ou 20.50 par exemple et supérieur ou égale à 0.',
    },
  },
};

export default messages;
